import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendAccountDeactivationRequestReminder = async ({ phoneNumber, purpose }: { phoneNumber: string; purpose: string }) => {
  const response = await mutationExecute({
    variables: {
      phoneNumber,
      purpose,
    },
    mutation: graphql(`
      mutation SendAccountDeactivationRequestReminder($phoneNumber: String!, $purpose: String!) {
        sendAccountDeactivationRequestReminder(phoneNumber: $phoneNumber, purpose: $purpose)
      }
    `),
  });

  return response.data?.sendAccountDeactivationRequestReminder ?? false;
};
